var cache = localStorage; // also supports 'sessionStorage'
//var cacheDuration = (1000 * 60 * 60 * 8) //8 hours
var cacheDuration = window.location.href.toLowerCase().indexOf('www.natptax.com') > -1 ? (1000 * 60 * 60 * 8) : (1000 * 30); //30 seconds for DEV

var _isExpired = function(cacheValue) {
	return Date.now() > cacheValue.expiration;
};

var get = exports.get = function(key) {
	var valueStr = cache.getItem(key);
	if (valueStr) {
		var val = JSON.parse(valueStr);
		return !_isExpired(val) ? val.payload : null
	}
	return null;
};

exports.set = function(key, payload, duration = cacheDuration) {
	var expiration = Date.now() + duration;
	cache.setItem(key, JSON.stringify({payload, expiration}));
	return get(key);
};



// WEBPACK FOOTER //
// ./src/scripts/shared/cache.js